var React = require('react');

function GoldenSection90 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M705 703.322C705 897.559 547.184 1055 352.484 1055C157.816 1055 0 897.559 0 703.322L0 0C389.368 0 705 314.881 705 703.29","fill":"currentColor"}));
}

GoldenSection90.defaultProps = {"width":"705","height":"1055","viewBox":"0 0 705 1055","fill":"none"};

module.exports = GoldenSection90;

GoldenSection90.default = GoldenSection90;
